import Helmet from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { SimplePageLayout } from 'components/layouts/SimplePageLayout';
import { PageLayout } from 'components/PageLayout';
import { LoginForm } from './LoginForm';

export const Content = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t('login.title')}</title>
      </Helmet>
      <SimplePageLayout>
        <LoginForm />
      </SimplePageLayout>
    </>
  );
};

export const Login = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <PageLayout
      data-cname="LoginPage"
      headerBarProps={{ action: '/', title: t('login.title') }}
    >
      <Content />
    </PageLayout>
  );
};
